import React from "react";
import { motion } from "framer-motion";
import { Leaf, ChefHat, Heart, Wheat, Home } from "lucide-react";

const ITEMS = [
  {
    icon: ChefHat,
    title: "Authentic village recipe",
    text: "Every jar follows a recipe passed down three generations in Karnataka.",
  },
  {
    icon: Leaf,
    title: "Freshly prepared",
    text: "Roasted and bottled in small weekly batches — never mass-produced.",
  },
  {
    icon: Wheat,
    title: "Quality ingredients",
    text: "Farm-fresh coconut, Byadgi chilies, cold-pressed oil, real jaggery.",
  },
  {
    icon: Heart,
    title: "Traditional taste",
    text: "The bold, smoky, earthy flavours you remember from a village home.",
  },
  {
    icon: Home,
    title: "Homemade feeling",
    text: "No preservatives, no shortcuts — just food made with real care.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      className="py-20 md:py-32 bg-stone-50"
      data-testid="why-choose-us-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="font-hand text-2xl text-[#993311]">— why halli</span>
          <h2 className="mt-2 font-serif text-3xl md:text-4xl lg:text-5xl leading-tight">
            Made the way it{" "}
            <span className="italic hand-underline">should be.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="group bg-white border border-stone-200/70 rounded-2xl p-8 hover:shadow-md transition-all"
                data-testid={`why-card-${i}`}
              >
                <div className="w-12 h-12 rounded-full bg-[#993311]/10 grid place-items-center text-[#993311] group-hover:bg-[#993311] group-hover:text-stone-50 transition-colors">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-6 font-serif text-xl md:text-2xl text-stone-900">
                  {it.title}
                </h3>
                <p className="mt-2 text-sm md:text-base text-stone-600 leading-relaxed">
                  {it.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
